// Helpers de documentos tributarios (DTE) compartidos por las vistas de facturas.
// `tipoDte` = tipo de DOCUMENTO (61 Nota de Crédito, 56 Nota de Débito, resto Factura).
// `tipo`    = tabla de ORIGEN del registro (PLAN/TAREA/AFECTA), define el tipo del proxy.

// Etiqueta visible del tipo de documento a partir de `tipoDte`.
// Acepta number o string ("61"/61); valor ausente/desconocido -> "Factura".
const labelTipoDte = (tipoDte) => {
  switch (Number(tipoDte)) {
    case 61:
      return "Nota de crédito";
    case 56:
      return "Nota de débito";
    default:
      return "Factura";
  }
};

// Prefijo filesystem-safe (sin espacios ni acentos) del nombre de archivo.
const prefijoArchivoDte = (tipoDte) => {
  switch (Number(tipoDte)) {
    case 61:
      return "NotaCredito";
    case 56:
      return "NotaDebito";
    default:
      return "Factura";
  }
};

// Nombre del archivo PDF a descargar. `folio` acepta number o string.
// Solo se considera inválido null/undefined o string vacío -> se omite el folio.
const nombreArchivoDte = (tipoDte, folio) => {
  const prefijo = prefijoArchivoDte(tipoDte);
  if (folio == null || String(folio).trim() === "") {
    return `${prefijo}.pdf`;
  }
  return `${prefijo}-${String(folio).trim()}.pdf`;
};

// Tipo del proxy (plan/tarea/afecta) a partir del `tipo` de tabla de la fila.
// Fail-fast: cualquier valor inesperado -> null (el llamador no debe descargar).
const tipoProxyDesdeFactura = (rowTipo) => {
  switch (String(rowTipo || "").toUpperCase()) {
    case "PLAN":
      return "plan";
    case "TAREA":
      return "tarea";
    case "AFECTA":
      return "afecta";
    default:
      return null;
  }
};

export {
  labelTipoDte,
  prefijoArchivoDte,
  nombreArchivoDte,
  tipoProxyDesdeFactura,
};
